import React from 'react'
import { AppButton, Tooltip } from '@clickguard/design-system'

/**
 * Copied from
 * `cg-dark-refunds/platform/src/components/refunds-agent/empty-no-ad-account.tsx`
 * (§2, Figma 6418-25648). Same markup, same classes, same tokens: the four the
 * fork was missing now sit in `tailwind.config.js` and `App.css` with the
 * source's own values.
 *
 * Two changes from the source, both forced by this page:
 *
 * 1. The icon is a prop. The source serves a product illustration from
 *    `/refunds-empty-no-account.svg` and Form Spam has no such asset, so the
 *    same 48px slot holds a glyph, and each caller picks the glyph that names
 *    its own empty.
 * 2. The CTA is `AppButton variant="primary"`, not the source's lime button.
 *    The lime is the Refunds Agent's accent. Form Spam runs the purple
 *    AppButton on every screen, and this CTA sits one fade away from the
 *    "Link new form" button, so the two must read as the same control.
 */
export const FormSpamEmptyState = ({
	icon,
	title,
	description,
	actionLabel,
	onAction,
	hint
}: {
	icon: React.ReactNode
	title: string
	description: string
	actionLabel: string
	onAction?: () => void
	hint: React.ReactNode
}) => (
	<div className="rounded-xl border cg-border-border-default cg-bg-surface p-6">
		<div className="flex flex-col items-center gap-[14px] rounded-xl border border-dashed cg-border-border-default cg-bg-surface-subtle px-6 py-[36px]">
			<div className="flex max-w-full flex-col items-center justify-center gap-3">
				{icon}
				<div className="flex max-w-full flex-col items-center gap-[6px]">
					<h3 className="text-[16px] font-medium leading-[22px] cg-text-text-primary">
						{title}
					</h3>
					<p className="w-[392px] max-w-full text-center text-[14px] leading-[18px] cg-text-text-secondary">
						{description}
					</p>
				</div>
			</div>
			<div className="h-[4px] w-px" />
			<AppButton variant="primary" size="md" label={actionLabel} onClick={onAction} disabled={!onAction} />
			<Tooltip
				theme="dark"
				position="bottom"
				showArrow
				content="How it works"
				description={hint}
			>
				<span className="cursor-default text-center text-[14px] font-medium cg-text-brand underline">
					How it works
				</span>
			</Tooltip>
		</div>
	</div>
)
